package org.teddapp.project.db

import com.tedd.db.TeddDatabase
import org.teddapp.project.db.repo.AccountRepository
import org.teddapp.project.db.repo.SkillResourceRepository
import org.teddapp.project.db.repo.AssetRepository
import org.teddapp.project.db.repo.CategoryRepository
import org.teddapp.project.db.repo.ExpenseListRepository
import org.teddapp.project.db.repo.FinanceAccountRepository
import org.teddapp.project.db.repo.FinanceCategoryRepository
import org.teddapp.project.db.repo.FinanceTransactionRepository
import org.teddapp.project.db.repo.FlashcardRepository
import org.teddapp.project.db.repo.FocusSessionRepository
import org.teddapp.project.db.repo.MilestoneRepository
import org.teddapp.project.db.repo.MindMapRepository
import org.teddapp.project.db.repo.ObjectiveProgressHistoryRepository
import org.teddapp.project.db.repo.CravingRepository
import org.teddapp.project.db.repo.ObjectiveReflectionRepository
import org.teddapp.project.db.repo.NoteRepository
import org.teddapp.project.db.repo.NotebookRepository
import org.teddapp.project.db.repo.ObjectiveRepository
import org.teddapp.project.db.repo.PomodoroCheckRepository
import org.teddapp.project.db.repo.PomodoroItemRepository
import org.teddapp.project.db.repo.PomodoroSessionRepository
import org.teddapp.project.db.repo.PortfolioRepository
import org.teddapp.project.db.repo.RecueilRepository
import org.teddapp.project.db.repo.OrganizationRepository
import org.teddapp.project.db.repo.PreferencesRepository
import org.teddapp.project.db.repo.ProjectRepository
import org.teddapp.project.db.repo.LoanRepository
import org.teddapp.project.db.repo.SimulationRepository
import org.teddapp.project.db.repo.SkillRepository
import org.teddapp.project.db.repo.ProjectStatusRepository
import org.teddapp.project.db.repo.TaskRepository
import org.teddapp.project.db.repo.TimerStateRepository
import org.teddapp.project.db.repo.UserProfileRepository
import org.teddapp.project.parcours.ParcoursImporter
import org.teddapp.project.parcours.ParcoursRepository

class TeddRepositories(val db: TeddDatabase) {
    val accounts         = AccountRepository(db)
    val notes            = NoteRepository(db)
    val notebooks        = NotebookRepository(db)
    val mindMaps         = MindMapRepository(db)
    val keychains        = org.teddapp.project.db.repo.KeychainRepository(db)
    val preferences      = PreferencesRepository(db)
    val userProfile      = UserProfileRepository(db)
    val focusSessions    = FocusSessionRepository(db)
    val categories       = CategoryRepository(db)
    val objectives       = ObjectiveRepository(db)
    val milestones       = MilestoneRepository(db)
    val objectiveHistory = ObjectiveProgressHistoryRepository(db)
    val reflections      = ObjectiveReflectionRepository(db)
    val cravings         = CravingRepository(db)
    val skills           = SkillRepository(db)
    val assets           = AssetRepository(db)
    val flashcards       = FlashcardRepository(db)
    val timerState       = TimerStateRepository(db)
    val progress         = ProgressService(db, objectiveHistory)
    val parcours         = ParcoursRepository(db)
    val parcoursImporter = ParcoursImporter(db, progress)
    val recueil          = RecueilRepository(db)
    val portfolio        = PortfolioRepository(db)
    val pomodoroSessions = PomodoroSessionRepository(db)
    val pomodoroItems    = PomodoroItemRepository(db)
    val pomodoroChecks   = PomodoroCheckRepository(db)
    val pomodoro         = PomodoroService(db, pomodoroSessions, pomodoroItems, progress)
    val organizations    = OrganizationRepository(db)
    val projects         = ProjectRepository(db)
    val projectStatus    = ProjectStatusRepository(db)
    val tasks            = TaskRepository(db)
    val financeAccounts  = FinanceAccountRepository(db)
    val financeCategories= FinanceCategoryRepository(db)
    val financeTxns      = FinanceTransactionRepository(db)
    val expenseLists     = ExpenseListRepository(db)
    val simulations      = SimulationRepository(db)
    val loans            = LoanRepository(db)
    val skillResources   = SkillResourceRepository(db)
    val assistant        = org.teddapp.project.db.repo.AssistantRepository(db)
}

fun createRepositories(factory: DatabaseDriverFactory): TeddRepositories =
    TeddRepositories(createTeddDatabase(factory))
